import { createReducer, on } from '@ngrx/store';
import { OpenFullscreenModalActions } from '@src/suite/common/store/fullscreen';
import { ApplicationActions } from '@src/suite/common/store/navigation/actions/application.actions';
import { secondsToTime } from '@src/suite/common/utils/timing-format';
import { LiveApiActions } from '@src/suite/live/store/actions/live.actions';
import { LiveState } from '@src/suite/live/store/models/live.models';

export const initialState: LiveState = {
    rundowns: [],
    currentRundown: null,
    rundownStories: {},
    storedLayoutNames: null,
    currentRundownLayout: null,
    storedViewStates: null,
    currentRundownViewState: null,
};

export const liveReducer = createReducer(
    initialState,
    // on(LiveApiActions.loadRundowns, (state): LiveState => {
    //     return {
    //         ...state,
    //         rundowns: [],
    //     };
    // }),
    on(LiveApiActions.loadRundownsSuccess, (state, { rundowns }): LiveState => {
        return {
            ...state,
            rundowns: [
                ...state.rundowns,
                ...rundowns.filter(ro => {
                    return !state.rundowns.find(item => item.Guid === ro.Guid);
                }),
            ],
        };
    }),
    on(LiveApiActions.loadCurrentRundownSuccess, (state, { data }): LiveState => {
        const roStories = data.children.reduce((acc, child) => {
            const mappedData = { ...child };
            if (child?.Guid && child.Guid !== '0') {
                // exclude last empty row and black row
                mappedData['BackTime'] = child['BackTimeFormatted'];
                mappedData['FrontTime'] = child['FrontTimeFormatted'];
                if (child['Actual'] == null) {
                    mappedData['Actual'] = secondsToTime(child['ReadTime']);
                }
                const titleChunks: Array<string> = mappedData['Title']?.split('-');
                mappedData['Slug'] = titleChunks[0] || '';
                mappedData['Title'] = titleChunks[0] || '';
                titleChunks.shift();
                mappedData['Segment'] = titleChunks.join('-');
            }
            acc[child.Guid] = mappedData;
            return acc;
        }, {});
        return {
            ...state,
            currentRundown: data,
            rundownStories: roStories,
        };
    }),
    on(LiveApiActions.loadRundownStoredLayoutsSuccess, (state, { data }): LiveState => {
        return {
            ...state,
            storedLayoutNames: data,
        };
    }),
    on(LiveApiActions.loadRundownLayoutSuccess, (state, { data }): LiveState => {
        return {
            ...state,
            currentRundownLayout: data,
        };
    }),
    on(LiveApiActions.freezeRundownPagesSuccess, (state, { data }): LiveState => {
        // TODO: Fix
        // const newRecord = RecordFactory.createRecordForType<RundownRecord>(ObjectTypesEnum.RUNDOWN);
        const newRecord = {} as StorytellingRundownRecord;
        // state.currentRundown.copyDataTo(newRecord);
        newRecord.FreezePages = data.pagesFrozen;
        Object.assign(newRecord.Layout, state.currentRundown.Layout);
        return {
            ...state,
            currentRundown: newRecord,
        };
    }),
    // on(LiveApiActions.realtimeUpdateStory, (state, { data }): LiveState => {
    //     //TODO: Fix this after NAB
    //     const newRundownStories = { ...state.rundownStories };

    //     const mappedData = Object.keys(data)
    //         .filter(key => {
    //             return !((data[key] instanceof DateTime && (<DateTime>data[key])?.moment?.year() === 1800) || key === 'CumeTime');
    //         })
    //         .reduce((acc, key) => {
    //             acc[key] = data[key];
    //             return acc;
    //         }, {});

    //     if (data['BackTimeFormatted']) {
    //         mappedData['BackTime'] = data['BackTimeFormatted'];
    //     }
    //     if (data['FrontTimeFormatted']) {
    //         mappedData['FrontTime'] = data['FrontTimeFormatted'];
    //     }
    //     if (data['Actual'] == null) {
    //         mappedData['Actual'] = secondsToTime(data['ReadTime']);
    //     }
    //     const titleChunks: Array<string> = mappedData['Title']?.split('-');
    //     mappedData['Slug'] = titleChunks[0] || '';
    //     mappedData['Title'] = titleChunks[0] || '';
    //     titleChunks.shift();
    //     mappedData['Segment'] = titleChunks.join('-');

    //     if (newRundownStories[data.Guid]) {
    //         newRundownStories[data.Guid] = {
    //             ...newRundownStories[data.Guid],
    //             ...mappedData,
    //         };
    //     } else {
    //         newRundownStories[data.Guid] = mappedData;
    //     }

    //     return {
    //         ...state,
    //         rundownStories: newRundownStories,
    //     };
    // }),
    // on(LiveApiActions.realtimeUpdateRundown, (state, { data }): LiveState => {
    //     //TODO: Fix this after NAB
    //     if (data.Guid === state.currentRundown?.Guid) {
    //         const roStories = data.children.reduce((acc, child) => {
    //             const mappedData = { ...child };
    //             if (child['Guid'] && child.Guid !== '0') {
    //                 // exclude last empty row and black row
    //                 mappedData['BackTime'] = child['BackTimeFormatted'];
    //                 mappedData['FrontTime'] = child['FrontTimeFormatted'];
    //                 if (child['Actual'] == null) {
    //                     mappedData['Actual'] = secondsToTime(child['ReadTime']);
    //                 }
    //                 const titleChunks: Array<string> = mappedData['Title']?.split('-');
    //                 mappedData['Slug'] = titleChunks[0] || '';
    //                 mappedData['Title'] = titleChunks[0] || '';
    //                 titleChunks.shift();
    //                 mappedData['Segment'] = titleChunks.join('-');
    //             }
    //             acc[child.Guid] = mappedData;
    //             return acc;
    //         }, {});
    //         return {
    //             ...state,
    //             currentRundown: data,
    //             rundownStories: roStories,
    //             rundowns: state.rundowns.map(ro => {
    //                 if (ro.Guid === data.Guid) {
    //                     return data;
    //                 }
    //                 return ro;
    //             }),
    //         };
    //     }
    //     return state;
    // }),
    on(LiveApiActions.loadRundownViewStatesSuccess, (state, { data }): LiveState => {
        return {
            ...state,
            storedViewStates: data,
        };
    }),
    on(ApplicationActions.setCurrentRundownViewState, (state, { guid }): LiveState => {
        return {
            ...state,
            currentRundownViewState: state?.storedViewStates?.views?.find(view => view.guid === guid) || null,
        };
    }),
    on(
        OpenFullscreenModalActions.closeRundwonFullscreenModal,
        (state): LiveState => ({
            ...state,
            currentRundown: null,
        })
    )
);
